import React, { useState, useEffect } from 'react';
import styles from './outerlayout.module.css';
import logo from '../../images/logo/pineapple-logo-black-text.png';
import { Outlet, useLocation } from 'react-router-dom';
import DeviceWarning from '../../components/common/deviceWarning/DeviceWarning';

const OuterLayout = () => {
	const location = useLocation();
	const [showWarning, setShowWarning] = useState(false);
	const [isSmallDevice, setIsSmallDevice] = useState(false);

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth',
		});
	}, [location]);

	useEffect(() => {
		// Check if device width is less than 1025px
		const checkDeviceWidth = () => {
			const width = window.innerWidth;
			setIsSmallDevice(width < 1281);
		};

		// Check on mount
		checkDeviceWidth();

		// Check on resize
		window.addEventListener('resize', checkDeviceWidth);

		return () => {
			window.removeEventListener('resize', checkDeviceWidth);
		};
	}, []);

	useEffect(() => {
		// Check if user has dismissed the warning in this session
		const hasAcknowledged = sessionStorage.getItem('deviceWarningAcknowledged');

		if (isSmallDevice && !hasAcknowledged) {
			setShowWarning(true);
		} else {
			setShowWarning(false);
		}
	}, [isSmallDevice]);

	const handleDismiss = () => {
		sessionStorage.setItem('deviceWarningAcknowledged', 'true');
		setShowWarning(false);
	};

	// If warning should be shown, only render the warning modal
	if (showWarning) {
		return <DeviceWarning onDismiss={handleDismiss} />;
	}

	// Otherwise, render the normal layout
	return (
		<div className={styles.container}>
			<div className={styles.formOuter}>
				<div className={styles.logoContainer}>
					<img src={logo} className={styles.logoImg} />
				</div>
				<Outlet />
				<div className={styles.footer}>
					<p>Copyright UTOUR Inc., d/b/a Pineapple {new Date().getFullYear()}</p>
				</div>
			</div>
			{/* <div className={styles.banner}>
                <img className={styles.w100} src={formImage}></img>
            </div> */}
		</div>
	);
};

export default OuterLayout;
